import { authXapi, externalXapi } from "./api-utils";

export const loadMarkdown = (link, path = "README.md") => {
  // tslint:disable-next-line:max-line-length
  return externalXapi(link).get(path);
};

export const generateArchiveUrl = async (file, region, project) => {
  const xapi = await authXapi();
  return xapi.get(`/archives/${file}?region=${region}&project=${project}`);
};

export const getRegions = async () => {
  const xapi = await authXapi();
  return xapi.get(`/regions`);
};
